export const RoutePaths = {
  home: "/",
  clearCookies: "/clear-cookies",
  profile: "/profile",
  notFound: "/not-found",
  tokenDump: "/token-dump",
};